import React from 'react'

interface Props {
  image: string
  alt: string
}
export const ModalBodyImage: React.FC<Props> = ({ image, alt }) => <img src={image} alt={alt} />
